import { useMutation } from '@tanstack/react-query';
import apiRequest from '../../../services/apiWrapper';
import { EMAIL_NOTIFICATION_URL } from '../../../utils/constants/urlConstants';
import type { EmailNotificationResendType } from '../../../utils/enums/email-notification-resend-type.enum';

async function resendEmailNotification(
  resendType: EmailNotificationResendType
) {
  return apiRequest.post(`${EMAIL_NOTIFICATION_URL}/${resendType}/send`, {});
}

export function useResendEmailNotification() {
  return useMutation({
    mutationFn: (resendType: EmailNotificationResendType) =>
      resendEmailNotification(resendType),
  });
}
